import { render, staticRenderFns } from "./CardBook.vue?vue&type=template&id=1d08e59a"
import script from "./CardBook.vue?vue&type=script&lang=js"
export * from "./CardBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports